<template>
  <el-dialog
     @close='cancle'
    :visible.sync="disableDialog"
    class="dialog-address"
    width="437px"
    title="提示">
    <div class="dialog-tip" >{{msg}}</div>
    <span slot="footer" class="dialog-center">
      <el-button @click="onSubmit" type="primary">确定</el-button>
      <el-button @click="cancle">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updateStopStorage } from '@/api/storage/storage'
export default {
  data () {
    return {
      disableDialog: false,
      params: {},
      msg: '',
      code: 0, // code 1 有锁库，0 没有锁库
      row: {}
    }
  },
  methods: {
    // 添加收货人初始化
    onInitialize (code, row) {
      this.code = code
      this.row = row
      if (this.row.flag === 0) {
        if (code === 0) {
          this.msg = '停用后,将失去该仓库相关的库存数据,您确定要继续吗？'
        } else if (code === 1) {
          this.msg = '该仓库有锁定库存不可停用'
        }
      } else {
        this.msg = '确定启用该仓库吗？'
      }
      this.disableDialog = true
    },
    // 选择地址后
    handleChange (label) {
    },
    // 提交
    onSubmit () {
      if (this.row.flag === 0) {
        if (this.code === 1) {
          this.disableDialog = false
        } else {
          // 停用仓库
          updateStopStorage(this.row.sbId, this.row.flag).then(res => {
            if (res.data.code === 200) {
              this.$message.success(res.data.msg)
              this.$emit('update')
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      } else {
        // 启用仓库
        updateStopStorage(this.row.sbId, this.row.flag).then(res => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg)
            this.$emit('update1')
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      }
      this.disableDialog = false
    },
    // 取消
    cancle () {
      this.disableDialog = false
      this.$parent.getList()

      // 刷新列表
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-tip{
    margin:10px 0 40px 30px;
  }
</style>
